import Vue from "vue";
import Router from "vue-router";

import { checkRole } from "./services/auth";

import AuthLayout from "@/layout/AuthLayout";
import BlankLayout from "@/layout/BlankLayout";

Vue.use(Router);

const router = new Router({
  linkExactActiveClass: "active",
  mode: "history",
  routes: [
    /* base routes */
    {
      path: "/",
      redirect: "login",
      component: AuthLayout,
      children: [
        {
          path: "/login",
          name: "login",
          component: () => import("./views/Login.vue"),
        },
        {
          path: "/register",
          name: "register",
          component: () => import("./views/Register.vue"),
        },
        {
          path: "/forgot-password",
          name: "forgot_password",
          component: () => import("./views/ForgotPassword.vue"),
        },
        {
          path: "/recover-password/:token/:email",
          name: "recover_password",
          component: () => import("./views/RecoverPassword.vue"),
        },
      ],
    },
    {
      path: "/",
      component: BlankLayout,
      children: [
        {
          path: "/investidor/politica-de-privacidade",
          name: "politica_de_privacidade",
          component: () => import("./views/PrivacyPolicy.vue"),
        },
        {
          path: "/soliticar-excluir-conta",
          name: "socilitar_exclusao_conta",
          component: () => import("./views/DeleteAccount.vue"),
        },
      ],
    },
    /* public routes */
    {
      path: "/selecoes",
      component: BlankLayout,
      children: [
        {
          path: ":slug/inscricao",
          name: "inscricao-selecao",
          component: () =>
            import("./views/Admin/Selecoes/FichaInscricao/InscricaoForm.vue"),
        },
      ],
    },
    /* admin routes */
    {
      path: "/admin",
      redirect: { name: "admin_dashboard" },
      component: () =>
        import(
          /* webpackChunkName: "adm-routes" */ "@/layout/admin/DashboardLayout"
        ),
      beforeEnter: (to, from, next) => {
        if (!checkRole("administrator")) next("/login");
        else next();
      },
      children: [
        {
          path: "/",
          alias: "dashboard",
          name: "admin_dashboard",
          meta: { title: "dashboard" },
          component: () => import("./views/Admin/Dashboard.vue"),
        },
        {
          path: "fundos",
          name: "admin_fundos",
          meta: { title: "fundos de investimentos" },
          component: () => import("./views/Admin/Fundos.vue"),
        },
        {
          path: "fundos/novo",
          name: "admin_fundos_new",
          meta: { title: "novo fundo de investimentos" },
          component: () => import("./views/Admin/Fundos/FundosForm.vue"),
        },
        {
          path: "fundos/:id/editar",
          name: "admin_fundos_edit",
          meta: { title: "editar fundo de investimentos" },
          component: () => import("./views/Admin/Fundos/FundosEdit.vue"),
        },
        {
          path: "fundos/:id/batches",
          name: "admin_fundos_batches",
          meta: { title: "fundo de investimentos - batches" },
          component: () => import("./views/Admin/Batches.vue"),
        },
        {
          path: "fundos/:id/investidores",
          name: "admin_fundos_investors",
          meta: { title: "fundo de investimentos - investidores" },
          component: () => import("./views/Admin/Fundos/FundosInvestors.vue"),
        },
        {
          path: "fundos/:id/metricas",
          name: "admin_fundos_metrics",
          meta: { title: "fundo de investimentos - métricas" },
          component: () => import("./views/Admin/Fundos/FundosMetricas.vue"),
        },
        {
          path: "fundos/:id/financeiro",
          name: "admin_fundos_financial",
          meta: { title: "fundo de investimentos - relatório financeiro" },
          component: () => import("./views/Admin/Fundos/FundosFinanceiro.vue"),
        },
        {
          path: "chamadas",
          name: "admin_chamadas",
          meta: { title: "chamadas" },
          component: () => import("./views/Admin/Chamadas.vue"),
        },
        {
          path: "chamadas/novo",
          name: "admin_chamadas_new",
          meta: { title: "nova chamada para startups" },
          component: () => import("./views/Admin/Chamadas/ChamadasForm.vue"),
        },
        {
          path: "chamadas/:id/editar",
          name: "admin_chamadas_edit",
          meta: { title: "editar chamada para startups" },
          component: () => import("./views/Admin/Chamadas/ChamadasEdit.vue"),
        },
        {
          path: "chamadas/:id/inscricoes",
          name: "admin_chamadas_inscricoes",
          meta: { title: "visualizar inscrições na chamada" },
          component: () =>
            import("./views/Admin/Chamadas/ChamadasInscricoes.vue"),
        },
        {
          path: "chamadas/:idCall/inscricoes/:idSubscription",
          name: "admin_chamadas_inscricao_view",
          meta: { title: "gerenciar inscrição" },
          component: () =>
            //alterado de ChamadasInscricaoView para ChamadasInscricaoView_v3 para estar de acordo com modificações feitas para batches a partir de 07/2024
            import("./views/Admin/Chamadas/ChamadasInscricaoView_v3.vue"),
        },
        {
          path: "chamadas/:id/inscricoes-tabela",
          name: "admin_chamadas_inscricoes-table",
          meta: { title: "visualizar inscrições na chamada" },
          component: () =>
            import("./views/Admin/Chamadas/ChamadasInscricoesTable.vue"),
        },
        {
          path: "chamadas/:id/avaliacao",
          name: "admin_chamadas_avaliacao",
          meta: { title: "gerenciar avaliação das startups" },
          component: () => import("./views/Admin/Chamadas/Avaliacao.vue"),
        },
        {
          path: "avaliacoes/:id/respostas",
          name: "admin_avaliacao_repostas",
          meta: { title: "avaliações dos investidores" },
          component: () =>
            import("./views/Admin/Chamadas/AvaliacaoRespostas.vue"),
        },
        {
          path: "chamadas/:id/pitch-day",
          name: "admin_pitch_day",
          meta: { title: "pitch day" },
          component: () => import("./views/Admin/Chamadas/PitchDay.vue"),
        },
        {
          path: "pitch-days/:id/respostas",
          name: "admin_pitch_day_repostas",
          meta: { title: "pitch day - avaliações dos investidores" },
          component: () =>
            import("./views/Admin/Chamadas/PitchDayRespostas.vue"),
        },
        {
          path: "chamadas/:id/due-diligence",
          name: "admin_due_diligence",
          meta: { title: "due diligence" },
          component: () => import("./views/Admin/Chamadas/DueDiligence.vue"),
        },
        {
          path: "batches",
          name: "admin_batches",
          meta: { title: "batches de startups" },
          component: () => import("./views/Admin/Batches.vue"),
        },
        {
          path: "batches/novo",
          name: "admin_batches_new",
          meta: { title: "novo batch" },
          component: () => import("./views/Admin/Batches/BatchesForm.vue"),
        },
        {
          path: "batches/:id/editar",
          name: "admin_batches_edit",
          meta: { title: "editar batches de startups" },
          component: () => import("./views/Admin/Batches/BatchesEdit.vue"),
        },
        {
          path: "batches/:idBatch/acompanhamento/startups/:idStartup/apresentacao",
          name: "admin_batches_startup_apresentacao",
          meta: { title: "apresentação da startup" },
          component: () =>
            import("./views/Admin/Batches/StartupApresentacao.vue"),
        },
        {
          path: "batches/:id/acompanhamento",
          name: "admin_batches_acompanhamento",
          meta: { title: "acompanhamento das startups" },
          component: () => import("./views/Admin/Batches/Tasks.vue"),
        },
        {
          path: "batches/:idBatch/acompanhamento/startups/:idStartup/respostas",
          name: "admin_batches_startup_tasks",
          meta: { title: "acompanhamento das startups" },
          component: () => import("./views/Admin/Batches/TaskStartup.vue"),
        },
        {
          path: "batches/:idBatch/acompanhamento/startups/:idStartup/relatorios",
          name: "admin_batches_startup_relatorios",
          meta: { title: "relatórios qualitativos da startup" },
          component: () =>
            import("./views/Admin/Batches/StartupRelatorios.vue"),
        },
        {
          path: "batches/:idBatch/acompanhamento/startups/:idStartup/metricas",
          name: "admin_batches_startup_report",
          meta: { title: "report mensal da startup" },
          component: () => import("./views/Admin/Batches/StartupMetrics.vue"),
        },
        {
          path: "batches/:idBatch/acompanhamento/startups/:idStartup/cards",
          name: "admin_batches_startup_cards",
          meta: { title: "cards personalizáveis" },
          component: () => import("./views/Admin/Batches/StartupCards.vue"),
        },
        {
          path: "batches/:idBatch/acompanhamento/startups/:idStartup/cards/novo",
          name: "admin_batches_startup_cards_new",
          meta: { title: "novo card personalizável" },
          component: () => import("./views/Admin/Batches/StartupCardForm.vue"),
        },
        {
          path: "batches/:idBatch/acompanhamento/startups/:idStartup/cards/:idCard/editar",
          name: "admin_batches_startup_cards_edit",
          meta: { title: "editar card personalizável" },
          component: () => import("./views/Admin/Batches/StartupCardEdit.vue"),
        },
        {
          path: "batches/:idBatch/acompanhamento/tarefas/:idTask/editar",
          name: "admin_batches_task_edit",
          meta: { title: "acompanhamento das startups - tarefa" },
          component: () => import("./views/Admin/Batches/TasksEdit.vue"),
        },
        {
          path: "batches/:idBatch/acompanhamento/tarefas/novo",
          name: "admin_batches_task_new",
          meta: { title: "acompanhamento das startups - nova tarefa" },
          component: () => import("./views/Admin/Batches/TasksForm.vue"),
        },
        {
          path: "mensagens",
          name: "admin_mensagens",
          meta: { title: "mensagens e notificações" },
          component: () => import("./views/Admin/Mensagens.vue"),
        },
        {
          path: "startups",
          name: "admin_startups",
          meta: { title: "startups" },
          component: () => import("./views/Admin/Startups.vue"),
        },
        {
          path: "startups-tabela",
          name: "admin_startups_table",
          meta: { title: "tabela de startups" },
          component: () => import("./views/Admin/Startups/StartupsTable.vue"),
        },
        {
          path: "startups/:id/editar",
          name: "admin_startups_edit",
          meta: { title: "editar startup" },
          component: () => import("./views/Admin/Startups/StartupEdit.vue"),
        },
        {
          path: "investidores",
          name: "admin_investors",
          meta: { title: "investidores" },
          component: () => import("./views/Admin/Investidores.vue"),
        },
        {
          path: "investidores-tabela",
          name: "admin_investors_table",
          meta: { title: "tabela de investidores" },
          component: () =>
            import("./views/Admin/Investidores/InvestidoresTable.vue"),
        },
        {
          path: "investidores/:id/editar",
          name: "admin_investors_edit",
          meta: { title: "editar investidor" },
          component: () =>
            import("./views/Admin/Investidores/InvestidorEdit.vue"),
        },
        {
          path: "acessos",
          name: "admin_acessos",
          meta: { title: "acessos" },
          component: () => import("./views/Admin/Acessos.vue"),
        },
        {
          path: "administradores/novo",
          name: "admin_admin_new",
          meta: { title: "novo administrador" },
          component: () => import("./views/Admin/Admins/AdminNew.vue"),
        },
        {
          path: "administradores/:id/editar",
          name: "admin_admin_edit",
          meta: { title: "editar administrador" },
          component: () => import("./views/Admin/Admins/AdminEdit.vue"),
        },
        {
          path: "configuracoes",
          name: "admin_configuracoes",
          meta: { title: "configurações" },
          component: () => import("./views/Admin/Configuracoes.vue"),
        },
        {
          path: "selecoes",
          name: "admin_selecoes",
          meta: { title: "seleções" },
          component: () => import("./views/Admin/Selecoes.vue"),
        },
        {
          path: "selecoes/nova",
          name: "admin_selecoes_new",
          meta: { title: "nova seleção" },
          component: () => import("./views/Admin/Selecoes/SelecoesForm.vue"),
        },
        {
          path: "selecoes/:id/editar",
          name: "admin_selecoes_edit",
          meta: { title: "editar seleção" },
          component: () => import("./views/Admin/Selecoes/SelecoesEdit.vue"),
        },
        {
          path: "selecoes/:id/inscricoes",
          name: "admin_selecoes_inscricoes",
          meta: { title: "visualizar inscrições na seleção" },
          component: () =>
            import("./views/Admin/Selecoes/SelecoesInscricoes.vue"),
        },
        {
          path: "selecoes/:id/inscricoes-tabela",
          name: "admin_selecoes_inscricoes-table",
          meta: { title: "visualizar inscrições na seleção" },
          component: () =>
            import("./views/Admin/Selecoes/SelecoesInscricoesTable.vue"),
        },
        {
          path: "selecoes/:idProcess/inscricoes/:idSubscription",
          name: "admin_selecoes_inscricao_view",
          meta: { title: "gerenciar inscrição" },
          component: () =>
            import("./views/Admin/Selecoes/SelecoesInscricaoView.vue"),
        },
        {
          path: "trilha",
          name: "admin_trilha",
          meta: { title: "trilha de qualificação" },
          component: () => import("./views/Admin/Trilha.vue"),
        },
        {
          path: "trilha/cursos/novo",
          name: "admin_cursos_new",
          meta: { title: "trilha de qualificação - novo curso" },
          component: () => import("./views/Admin/Trilha/CursosForm.vue"),
        },
        {
          path: "trilha/cursos/:id/editar",
          name: "admin_cursos_edit",
          meta: { title: "trilha de qualificação - editar curso" },
          component: () => import("./views/Admin/Trilha/CursosEdit.vue"),
        },
        {
          path: "trilha/cursos/:id/ranking",
          name: "admin_cursos_ranking",
          meta: { title: "trilha de qualificação - ranking de acesso" },
          component: () => import("./views/Admin/Trilha/Ranking.vue"),
        },
        {
          path: "trilha/cursos/:id/materiais",
          name: "admin_cursos_materials",
          meta: { title: "trilha de qualificação - materiais do curso" },
          component: () => import("./views/Admin/Trilha/Materiais.vue"),
        },
        {
          path: "trilha/cursos/:id/materiais/novo",
          name: "admin_cursos_materials_novo",
          meta: { title: "trilha de qualificação - materiais do curso" },
          component: () =>
            import("./views/Admin/Trilha/Materiais/MateriaisForm.vue"),
        },
        {
          path: "trilha/cursos/:idCurso/materiais/:idMaterial/editar",
          name: "admin_cursos_materials_editar",
          meta: { title: "trilha de qualificação - materiais do curso" },
          component: () =>
            import("./views/Admin/Trilha/Materiais/MateriaisEdit.vue"),
        },
        {
          path: "trilha/cursos/:id/materiais/ordenar",
          name: "admin_cursos_materials_ordenar",
          meta: {
            title: "trilha de qualificação - ordenar materiais do curso",
          },
          component: () =>
            import("./views/Admin/Trilha/Materiais/MateriaisSort.vue"),
        },
        {
          path: "trilha/cursos/:id/materiais/secoes",
          name: "admin_cursos_materials_secoes",
          meta: {
            title: "trilha de qualificação - gerenciar seções do curso",
          },
          component: () =>
            import("./views/Admin/Trilha/Materiais/Sections.vue"),
        },
        {
          path: "trilha/cursos/:idCurso/avaliacoes/:idAvaliacao/respostas",
          name: "admin_cursos_materials_answers",
          meta: {
            title: "trilha de qualificação - respostas dos colaboradores",
          },
          component: () =>
            import("./views/Admin/Trilha/Materiais/AvaliacaoRespostas.vue"),
        },
        {
          path: "beneficios-aceleradas",
          name: "admin_beneficios_aceleradas",
          meta: {
            title: "benefícios aceleração",
          },
          component: () => import("./views/Admin/Parcerias.vue"),
        },
        {
          path: "beneficios-aceleradas/novo",
          name: "admin_beneficios_aceleradas_new",
          meta: {
            title: "novo benefício aceleração",
          },
          component: () => import("./views/Admin/Parcerias/ParceriasForm.vue"),
        },
        {
          path: "beneficios-aceleradas/:id/editar",
          name: "admin_beneficios_aceleradas_edit",
          meta: {
            title: "editar benefício aceleração",
          },
          component: () => import("./views/Admin/Parcerias/ParceriasEdit.vue"),
        },
        {
          path: "networking-secreto-startups",
          name: "admin_networking_secreto",
          meta: {
            title: "networking secreto Startup",
          },
          component: () =>
            import("./views/Admin/NetworkingSecreto/NetworkingSecreto.vue"),
        },
        {
          path: "networking-secreto",
          name: "admin_networking_secreto_investidor",
          meta: {
            title: "networking secreto Investidor",
          },
          component: () =>
            import(
              "./views/Admin/NetworkingSecreto/NetworkingSecretoInvestidor.vue"
            ),
        },
      ],
    },
    /* startup routes */
    {
      path: "/startup",
      redirect: { name: "startup_dashboard" },
      component: () =>
        import(
          /* webpackChunkName: "startup-routes" */ "@/layout/startup/DashboardLayout"
        ),
      beforeEnter: (to, from, next) => {
        if (!checkRole("startup")) next("/login");
        else next();
      },
      children: [
        {
          path: "/",
          alias: "dashboard",
          name: "startup_dashboard",
          meta: { title: "dashboard" },
          component: () => import("./views/Startup/Dashboard.vue"),
        },
        {
          path: "chamadas",
          name: "startup_chamadas",
          meta: { title: "chamadas para startups em aberto" },
          component: () => import("./views/Startup/Chamadas.vue"),
        },
        {
          path: "chamadas/inscricoes",
          name: "startup_inscricoes",
          meta: { title: "Histórico de inscrições" },
          component: () => import("./views/Startup/Chamadas/Inscricoes.vue"),
        },
        {
          path: "chamadas/:id/inscricao",
          name: "startup_inscricao",
          meta: { title: "Painel de inscrição" },
          //alterado de InscricaoForm para InscricaoForm_v3 para estar de acordo com modificações feitas para batches a partir de 07/2024
          component: () =>
            import("./views/Startup/Chamadas/InscricaoForm_v3.vue"),
        },
        {
          path: "inscricoes/:id/visualizar",
          name: "startup_inscricao_view",
          meta: { title: "Visualizar inscrição - resumo" },
          //alterado de InscricaoView para InscricaoView_v3 para estar de acordo com modificações feitas para batches a partir de 07/2024
          component: () =>
            import("./views/Startup/Chamadas/InscricaoView_v3.vue"),
        },
        {
          path: "inscricoes/:id/editar",
          name: "startup_inscricao_edit",
          meta: { title: "editar inscrição" },
          //alterado de InscricaoEdit para InscricaoEdit_v3 para estar de acordo com modificações feitas para batches a partir de 07/2024
          component: () =>
            import("./views/Startup/Chamadas/InscricaoEdit_v3.vue"),
        },
        {
          path: "batches",
          name: "startup_batches",
          meta: { title: "Batches de startups" },
          component: () => import("./views/Startup/Batches.vue"),
        },
        {
          path: "batches/:id/startups",
          name: "startup_batches_startups",
          meta: { title: "startups selecionadas" },
          component: () => import("./views/Startup/Batches/BatchStartups.vue"),
        },
        {
          path: "batches/:id/acompanhamento",
          name: "startup_batches_acompanhamento",
          meta: { title: "batch de startups stars" },
          component: () =>
            import("./views/Startup/Batches/BatchAcompanhamento.vue"),
        },
        {
          path: "batches/:idBatch/acompanhamento/tasks/:idTask/resposta",
          name: "startup_task_response",
          meta: { title: "batch de startups stars - ficha resposta" },
          component: () =>
            import("./views/Startup/Batches/TaskResponseForm.vue"),
        },
        {
          path: "batches/:idBatch/acompanhamento/tasks/:idTask/visualizar",
          name: "startup_task_view",
          meta: { title: "batch de startups stars - ficha resposta" },
          component: () =>
            import("./views/Startup/Batches/TaskResponseView.vue"),
        },
        {
          path: "pre-aceleracao",
          name: "startup_pre_aceleracao",
          meta: { title: "programa de pré-aceleração" },
          component: () => import("./views/Startup/PreAceleracao.vue"),
        },
        {
          path: "configuracoes",
          name: "startup_configuracoes",
          meta: { title: "configurações" },
          component: () => import("./views/Startup/Configuracoes.vue"),
        },
        {
          path: "suporte",
          name: "startup_suporte",
          meta: { title: "suporte" },
          component: () => import("./views/Startup/Suporte.vue"),
        },
        {
          path: "trilha",
          name: "startup_trilha",
          meta: { title: "trilha de qualificação" },
          component: () => import("./views/Startup/Trilha.vue"),
        },
        {
          path: "trilha/cursos/:id/visualizar",
          name: "startup_curso",
          meta: { title: "trilha de qualificação - curso" },
          component: () => import("./views/Startup/Trilha/CursoView.vue"),
        },
        {
          path: "beneficios-aceleradas",
          name: "startup_beneficios_aceleradas",
          meta: { title: "benefícios aceleração stars" },
          component: () => import("./views/Startup/Parcerias.vue"),
        },
      ],
    },
    /* investidor routes */
    {
      path: "/investidor",
      redirect: { name: "investidor_dashboard" },
      component: () =>
        import(
          /* webpackChunkName: "investor-routes" */ "@/layout/investidor/DashboardLayout"
        ),
      beforeEnter: (to, from, next) => {
        if (!checkRole("investor")) next("/login");
        else next();
      },
      children: [
        {
          path: "/",
          alias: "dashboard",
          name: "investidor_dashboard",
          meta: { title: "dashboard" },
          component: () => import("./views/Investor/Dashboard.vue"),
        },
        {
          path: "batches",
          name: "investidor_batches",
          meta: { title: "batches de startups" },
          component: () => import("./views/Investor/Batches.vue"),
        },
        {
          path: "batches/:id/startups",
          name: "investidor_batches_startups",
          meta: { title: "batch de startups" },
          component: () => import("./views/Investor/Batches/BatchStartups.vue"),
        },
        {
          path: "/investidor/batches/:idBatch/startup/:idStartup/acompanhamento",
          name: "investidor_batches_acompanhamento",
          meta: { title: "Batch: Acompanhamento e métricas" },
          component: () =>
            import("./views/Investor/Batches/StartupAcompanhamento.vue"),
        },
        {
          path: "/investidor/batches/:idBatch/startup/:idStartup/apresentacao",
          name: "investidor_batches_apresentacao",
          meta: { title: "Batch: Apresentação" },
          component: () =>
            import("./views/Investor/Batches/StartupApresentacao.vue"),
        },
        {
          path: "/investidor/batches/:idBatch/startup/:idStartup/relatorios",
          name: "investidor_batches_relatorios",
          meta: { title: "Batch: Relatórios qualitativos" },
          component: () =>
            import("./views/Investor/Batches/StartupRelatorios.vue"),
        },
        {
          path: "avaliacoes",
          name: "investidor_avaliacoes",
          meta: { title: "avaliações de startups em aberto" },
          component: () => import("./views/Investor/Avaliacoes.vue"),
        },
        {
          path: "avaliacoes/:id/startups",
          name: "investidor_avaliacoes_startups",
          meta: { title: "avaliações de startups" },
          component: () =>
            import("./views/Investor/Evaluations/AvaliacaoStartups.vue"),
        },
        {
          path: "avaliacoes/:idEvaluation/inscricoes/:idSubscription/avaliar",
          name: "investidor_avaliacao_startup",
          meta: { title: "avaliação da startup" },
          //alterado de Avaliacao para Avaliacao_v3 para estar de acordo com modificações feitas para batches a partir de 07/2024
          component: () =>
            import("./views/Investor/Evaluations/Avaliacao_v3.vue"),
        },
        {
          path: "pitch-days",
          name: "investidor_pitch_days",
          meta: { title: "pitch days" },
          component: () => import("./views/Investor/PitchDays.vue"),
        },
        {
          path: "pitch-days/:id/startups",
          name: "investidor_pitch_day_startups",
          meta: { title: "pitch day - startups" },
          component: () =>
            import("./views/Investor/PitchDay/PitchDayStartups.vue"),
        },
        {
          path: "pitch-days/:idPitchDay/inscricoes/:idSubscription/avaliar",
          name: "investidor_pitch_day_startup",
          meta: { title: "pitch day - avaliação da startup" },
          component: () =>
            import("./views/Investor/PitchDay/PitchDayAvaliacao.vue"),
        },
        {
          path: "due-diligences",
          name: "investidor_due_diligences",
          meta: { title: "due diligences" },
          component: () => import("./views/Investor/DueDiligences.vue"),
        },
        {
          path: "due-diligences/:id/startups",
          name: "investidor_due_diligence_startups",
          meta: { title: "due diligence - startups" },
          component: () =>
            import("./views/Investor/DueDiligence/DueDiligenceStartups.vue"),
        },
        {
          path: "due-diligences/:idDueDiligence/inscricoes/:idSubscription/visualizar",
          name: "investidor_due_diligence_startup",
          meta: { title: "due diligence - visualizar startup" },
          component: () =>
            import("./views/Investor/DueDiligence/DueDiligenceView.vue"),
        },
        {
          path: "configuracoes",
          name: "investidor_configuracoes",
          meta: { title: "configurações" },
          component: () => import("./views/Investor/Configuracoes.vue"),
        },
        {
          path: "suporte",
          name: "investidor_suporte",
          meta: { title: "suporte" },
          component: () => import("./views/Investor/Suporte.vue"),
        },
        {
          path: "networking-secreto",
          name: "investidor_networking_secreto",
          meta: { title: "" },
          component: () => import("./views/Investor/NetworkingSecreto.vue"),
        },
      ],
    },
    /* fallback route (404) */
    { path: "*", redirect: "login" },
  ],
});

router.beforeEach((to, from, next) => {
  const toBaseRoute = ["/", "/login", "/register"].includes(to.fullPath);
  // if user is trying to access the login/register page
  if (toBaseRoute) {
    // if user is authenticated redirect to his respective panel (based on user role)
    if (checkRole("administrator")) next("/admin");
    else if (checkRole("startup")) next("/startup");
    else if (checkRole("investor")) next("/investidor");
    else next();
  }
  // go to next route (will check user role in beforeRoute)
  else next();
});

export default router;
